// extracted by mini-css-extract-plugin
module.exports = {"bulk_assignment_popup":"styles_bulk_assignment_popup__3G3f1","bulk_assignment_popup__recipients":"styles_bulk_assignment_popup__recipients__2bbiZ"};